import { connect } from 'react-redux'
import PatientEkgRecording from './PatientEkgRecording'
import {
  setInitialPatientEkgRecordingData,
  clearSelections,
  updateSelectedReassignInboxId,
  confirmAndArchiveCallback,
  reassignCallback,
} from './module'

const mapActionCreators = {
  setInitialPatientEkgRecordingData,
  clearSelections,
  updateSelectedReassignInboxId,
  confirmAndArchiveCallback,
  reassignCallback,
}

const mapStateToProps = state => ({
  selectedRecordingId: state.patientEkgRecording.selectedRecordingId,
  selectedReassignInboxId: state.patientEkgRecording.selectedReassignInboxId,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(PatientEkgRecording)



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientEkgRecording/container.js